import React, { useState, useContext } from 'react';
import UserContext from '../../context/Globales/UserContext';
import {

    makeStyles,
    TableContainer, Table, TableCell, TableRow, TableBody, Button, Divider, Modal, Fade, Backdrop
} from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import IcpdfConyuge from '../pdf/IC/IcpdfConyuge';



const formatterPeso = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP'
})



const useStyles = makeStyles((theme) => ({
    tituloTable: {

        backgroundColor: '#e6e6e6',
        minWidth: 200,
        color: 'black',
        textAlign: 'center',
        padding: '16px',
        fontWeight: '250',
        fontSize: '16px'
    },
    tituloTable2: {

        backgroundColor: theme.palette.fondotitulos.main,
        // backgroundImage : `url(${FondoImagenes})`,

        minWidth: 200,
        color: '#171717',
        textAlign: 'center',
        padding: '20px',
        fontWeight: '250',
        fontSize: '35px'
    },
    TituloIdentificacion: {

        backgroundColor: theme.palette.primary.main,
        minWidth: 200,
        color: 'white',
        textAlign: 'center',
        padding: '15px',
        fontWeight: '250',
        fontSize: '18px',
        height: 'auto',
        alignContent: 'center',
    },
    FondoTable: {

        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 440,
        maxWidth: '100%'
    },
    modalPdf: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    paperPdf: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '50%',
    },
}));

const TblDetalleConyuge = () => {
    const classes = useStyles();


    const { Datodetalleconyuge } = useContext(UserContext);
    const [OpenModalpdfconyuge, setOpenModalpdfconyuge] = React.useState(false);

    const handlClickOpenModal = () => {
        setOpenModalpdfconyuge(!OpenModalpdfconyuge)
    };

    const handleClickclosemodal = () => {

        setOpenModalpdfconyuge(false);
    }


    return (
        <div>
            {/*MODAL PDF INFORME COMER*/}

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modalPdf}
                open={OpenModalpdfconyuge}
                onClose={handleClickclosemodal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 2000,
                }}>
                <Fade in={OpenModalpdfconyuge}>

                    <div className={classes.paperPdf}>


                        <IcpdfConyuge />



                    </div>

                </Fade>
            </Modal>






            <h5>{Datodetalleconyuge && Datodetalleconyuge == 'ERROR CONSULTA CONYUGE' ?
                'Error al procesar su solicitud, inténtelo mas tarde (INFORME COMERCIAL)' : ''}</h5>

            <h5 className={classes.tituloTable}>Detalle Conyuge</h5>

            {Datodetalleconyuge ? <div style={{ alignContent: "center", textAlign: "center" }}><Button variant="contained" color="primary" onClick={handlClickOpenModal}>Descargar PDF</Button></div> : ''}
            <br />
            {!Datodetalleconyuge ? <h2>Cargando informacón...</h2> : (



                <TableContainer className={classes.containerTable}>
                    <div className={classes.tituloTable2}>
                        {  Datodetalleconyuge && Datodetalleconyuge?.Nombre}
                    </div>

                    <Divider />
                    <Table size="small">
                        <TableBody >

                            <TableRow>
                                <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Rut:</strong></TableCell>
                                <TableCell>{Datodetalleconyuge && Datodetalleconyuge?.Rut}</TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Fecha. Nacimiento:</strong></TableCell>
                                <TableCell>{Datodetalleconyuge && Datodetalleconyuge?.FechaNacimiento}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Edad:</strong></TableCell>
                                <TableCell>{Datodetalleconyuge && Datodetalleconyuge?.Edad}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Fecha Matrimonio:</strong></TableCell>
                                <TableCell>{Datodetalleconyuge && Datodetalleconyuge?.FechaMatrimonio}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Direccion:</strong></TableCell>
                                <TableCell>{Datodetalleconyuge && Datodetalleconyuge?.Direccion}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Comuna:</strong></TableCell>
                                <TableCell>{  Datodetalleconyuge && Datodetalleconyuge?.Comuna}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Ciudad:</strong></TableCell>
                                <TableCell>{  Datodetalleconyuge && Datodetalleconyuge?.Ciudad}</TableCell>
                            </TableRow>


                        </TableBody>

                    </Table>

                </TableContainer>
            )}


        </div>
    )
}

export default TblDetalleConyuge;
